import { eventQBus } from "@otto-ec/event-q-bus";
import { o_global } from "./namespaces";

/*                                              */
o_global.eventQBus ||= eventQBus();
o_global.events ||= () => o_global.eventQBus as never;
